export var WORKSHOPS_BG_COLORS = {
  'workshops-color-grey': 'workshopGray',
  'workshops-color-indigo': 'primaryIndigo',
  'workshops-color-blue': 'passionate',
  'workshops-color-pink': 'human',
  'workshops-color-red': 'bold',
  'workshops-color-yellow': 'outspoken',
  'workshops-color-white': 'primaryWhite'
};
export var isHighContrastColor = function isHighContrastColor(color) {
  var highContrastBgColors = ['workshops-color-indigo', 'workshops-color-blue', 'workshops-color-red'];
  return highContrastBgColors.includes(color);
};